import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { inboxLoginStatus } from '@/state/inboxAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/inbox/routes';

export type UnauthenticatedRouteProps = RouteProps;

const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(inboxLoginStatus);

  if (loginStatus === 'LOGGED_IN') {
    return <Redirect to={routes.inbox} />;
  }

  return <SentryRoute {...props} />;
};

export default UnauthenticatedRoute;
